import React, { Component, PropTypes } from 'react';

class PagesConfirmation extends Component {
    render() {
        return (
            <div>
                Content of PagesConfirmation
                <hr />
                {this.props.children}
            </div>
        );
    }
}

PagesConfirmation.propTypes = {
    children: PropTypes.element
};

export default PagesConfirmation;



// WEBPACK FOOTER //
// ./src/components/pages/pages/PagesConfirmation.js